module.exports = __webpack_public_path__ + "static/media/logo-sfs.9236928b.png";